import { useQuery } from "@tanstack/react-query";
import { dynamicFormList } from "../../../../services/dynamicFormService";
import { toast } from "react-toastify";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

const Forms = () => {
  const navigate = useNavigate();

  const filters = useMemo(
    () => ({
      limit: 10000,
      page: 1,
      sortQuery: "createdAt",
    }),
    []
  );

  const { data } = useQuery({
    queryKey: ["dynamic-form", filters],
    queryFn: async () => {
      const res = await dynamicFormList({
        ...filters,
      });
      if (res?.status !== 200) toast.warning(res?.message);
      return res?.docs;
    },
  });

  return (
    <>
      <div className="px-6 rounded-md space-y-4">
        <h4 className="text-[40px] text-primary text-deep-purple font-bold font-Montserrat mb-3">Dynamic Form</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          <div
            onClick={() => {
              navigate("sections");
            }}
            className="flex items-center justify-center border-2 border-dashed rounded-2xl cursor-pointer p-6 text-gray-500 hover:bg-gray-50 transition"
          >
            + Add Form
          </div>
          {data?.data.map((item, i) => (
            <div
              key={item._id}
              className="group relative p-6 bg-gradient-to-br from-white to-gray-50 rounded-2xl cursor-pointer 
             shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
              onClick={() => {
                navigate("sections", { state: { form: item } });
              }}
            >
              <h3 className="text-xl font-bold text-gray-800 group-hover:text-indigo-600 transition-colors">{item.title}</h3>
              <p className="mt-2 text-sm text-gray-600 line-clamp-2">{item.description}</p>
              <div className="mt-4 flex items-center justify-between text-xs text-gray-400">
                <span className="px-2 py-1 rounded-full bg-indigo-100 text-indigo-600 font-medium absolute bottom-4 right-4">Form {i + 1}</span>
              </div>
              <div className="absolute inset-0 rounded-2xl bg-indigo-50 opacity-0 group-hover:opacity-10 transition"></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default Forms;
